/*
  HALO Vitrine: a imagem do anel se move com a rolagem. Ao descer a página, ela inclina
  (rotateX, efeito de girar), gira um pouco no plano e desce; ao subir, faz o inverso. No meio
  da tela fica na posição original. O movimento segue a rolagem com uma leve suavização.
  Só escuta a rolagem enquanto a seção está perto da tela. Com "menos movimento", fica parada.
*/
(function () {
  'use strict';

  if (customElements.get('halo-vitrine')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  class HaloVitrine extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-motion') || reduce.matches) return;
      this.media = this.querySelector('[data-hv-media]');
      if (!this.media) return;
      this.tilt = parseFloat(this.dataset.tilt) || 0;
      this.rotate = parseFloat(this.dataset.rotate) || 0;
      this.shift = parseFloat(this.dataset.shift) || 0;
      this.shown = this.target();
      this.raf = 0;
      this.render(this.shown);

      var self = this;
      this.onScroll = function () {
        if (!self.raf) self.raf = requestAnimationFrame(self.tick.bind(self));
      };
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          window.addEventListener('scroll', self.onScroll, { passive: true });
          self.onScroll();
        } else {
          window.removeEventListener('scroll', self.onScroll);
        }
      }, { rootMargin: '25% 0px' });
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    // De -1 (seção entrando por baixo) a 1 (saindo por cima); 0 com a seção no meio da tela.
    target() {
      var rect = this.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var p = clamp((vh - rect.top) / (vh + rect.height), 0, 1);
      return p * 2 - 1;
    }

    tick() {
      this.raf = 0;
      var goal = this.target();
      this.shown += (goal - this.shown) * 0.18;
      if (Math.abs(goal - this.shown) < 0.001) this.shown = goal;
      this.render(this.shown);
      if (this.shown !== goal) this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    render(t) {
      this.media.style.transform =
        'rotateX(' + (t * this.tilt).toFixed(2) + 'deg) ' +
        'rotate(' + (t * this.rotate).toFixed(2) + 'deg) ' +
        'translateY(' + (t * this.shift).toFixed(2) + '%)';
    }
  }

  customElements.define('halo-vitrine', HaloVitrine);
})();
